import { History } from "history"

/**
 * Navigates to a page keeping the query strings intact
 */
export const navigateToNextPage = (path: string, history: History) => {
  history.push(`${path}${history.location.search}`)
}
